module.exports = __webpack_public_path__ + "img/capm.81e91d11.png";